import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';
import App from './app/App';
import { Provider } from 'react-redux';
import store from './app/utils/store';
import registerServiceWorker from './registerServiceWorker';
ReactDOM.render(
    <Provider store={store} >
        <App />
    </Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js